import i18n from "i18n";
export const STATUS_ORDER = ["healthy", "warning", "critical", "unknown"];
export const STATUS_ICONS = {
  healthy: "check_circle",
  warning: "warning",
  critical: "error",
  unknown: "help"
};
export const STATUS_BADGE_COLORS = {
  healthy: "success",
  warning: "warning",
  critical: "danger",
  unknown: "gray"
};
export const getStatusLabel = (status) => i18n.t(`health.status.${status}`, { ns: "enterprise_license" });
export const getStatusDescription = (status) => i18n.t(`health.status_description.${status}`, { ns: "enterprise_license" });
export const getStatusMeta = (status) => ({
  label: getStatusLabel(status),
  description: getStatusDescription(status)
});
export const formatStatusList = (statuses) => statuses.length === 2 ? i18n.t("health.status_list_or", {
  ns: "enterprise_license",
  first: getStatusLabel(statuses[0]),
  second: getStatusLabel(statuses[1])
}) : statuses.map(getStatusLabel).join(", ");
